import React from "react";
import styled from "styled-components";
import { Flex } from "@ebscois/react-component-library";
import {
  NAV_BREAKPOINT,
  CONTENT_OFFSET_MOBILE,
  CONTENT_OFFSET_TABLET,
  CONTENT_OFFSET_DESKTOP
} from "../../utils/constants";

export const RouteContent = styled((props) => (
  <Flex {...props} id="main-content" container column />
))`
  ${({ theme, $isFluid }) =>
    $isFluid
      ? `
  max-width: inherit;
  margin-top: ${CONTENT_OFFSET_MOBILE}rem;
  `
      : `
    padding: 1rem ${theme.space.gutter.base};
    margin: ${CONTENT_OFFSET_MOBILE}rem auto 0;
  `};
  flex: 1 0 auto;
  width: 100%;
  ${(props) => props.$isFlexCell && `display: flex;`};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: ${CONTENT_OFFSET_TABLET}rem;
    ${(props) => !props.$isFluid && `padding: 1.5rem 1rem;`}
  }

  @media screen and (min-width: ${NAV_BREAKPOINT}) {
    margin-top: ${CONTENT_OFFSET_DESKTOP}rem;
  }

  @media print {
    margin: 0 !important;
  }
`;
